import api from "./api";

export const exchangeBikeService = {

  // 📊 Get exchange bikes (with filters)
  getExchangeBikes: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/exchange-bike?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📑 Get exchange bikes full detail (exchange bike + parent bike + sale + payments) for Excel
  getExchangeBikesFullDetail: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/exchange-bikes/full-detail?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSpecificBike: async (id) => {
    try {
      const response = await api.get(`/specific-bike-details/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateExchangeBike: async (updateBike) => {
    try {
      const response = await api.put(`/update-exchange-bike/${updateBike._id}`, updateBike);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 AddExchangeBikeAmount: async (saleId, stockData) => {
    try {
      const response = await api.post(`/add-exchange-payment/${saleId}`, stockData);
      return response.data;
    } catch (error) {
      throw error;
    }
},
UpdateExchangePayment: async (saleId, data) => {
  try {
    const response = await api.put(
      `/update-sale-exchange-payment/${saleId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

};